var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { File } from "./File";
import { RejectReason } from "./RejectReason";
import { SubmissionProof } from "./SubmissionProof";
import { DateConverter } from "./../../../converters/DateConverter";
export class SubmissionPeriodFiles {
  constructor(_data) {
    /**
     */
    __publicField(this, "ApprovedBy");
    /**
     */
    __publicField(this, "ClientApprovalDate");
    /**
     */
    __publicField(this, "DataVatFiles");
    /**
     */
    __publicField(this, "InvalidVatNumbersReportFiles");
    /**
     */
    __publicField(this, "NotToBeSubmittedProof");
    /**
     */
    __publicField(this, "OutOfScopeFiles");
    /**
     */
    __publicField(this, "RecoverPercentageExceptionListFiles");
    /**
     */
    __publicField(this, "RejectReasons");
    /**
     */
    __publicField(this, "ReopenReason");
    /**
     */
    __publicField(this, "ReturnFiles");
    /**
     */
    __publicField(this, "SubmissionErrorFiles");
    /**
     */
    __publicField(this, "SubmissionProofs");
    /**
     */
    __publicField(this, "TransactionFiles");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SubmissionPeriodFiles
     */
    __publicField(this, "$type", "V1.SubmissionPeriods.SubmissionPeriodFiles");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.ApprovedBy = _data["ApprovedBy"];
      this.ClientApprovalDate = DateConverter.from(_data["ClientApprovalDate"]);
      if (_data["DataVatFiles"] && _data["DataVatFiles"].constructor === Array) {
        this.DataVatFiles = [];
        for (let item of _data["DataVatFiles"]) {
          const dataVatFiles_ = new File();
          this.DataVatFiles.push(dataVatFiles_.init(item));
        }
      }
      if (_data["InvalidVatNumbersReportFiles"] && _data["InvalidVatNumbersReportFiles"].constructor === Array) {
        this.InvalidVatNumbersReportFiles = [];
        for (let item of _data["InvalidVatNumbersReportFiles"]) {
          const invalidVatNumbersReportFiles_ = new File();
          this.InvalidVatNumbersReportFiles.push(invalidVatNumbersReportFiles_.init(item));
        }
      }
      if (_data["NotToBeSubmittedProof"]) {
        const notToBeSubmittedProof_ = new File();
        this.NotToBeSubmittedProof = notToBeSubmittedProof_.init(_data["NotToBeSubmittedProof"]);
      }
      if (_data["OutOfScopeFiles"] && _data["OutOfScopeFiles"].constructor === Array) {
        this.OutOfScopeFiles = [];
        for (let item of _data["OutOfScopeFiles"]) {
          const outOfScopeFiles_ = new File();
          this.OutOfScopeFiles.push(outOfScopeFiles_.init(item));
        }
      }
      if (_data["RecoverPercentageExceptionListFiles"] && _data["RecoverPercentageExceptionListFiles"].constructor === Array) {
        this.RecoverPercentageExceptionListFiles = [];
        for (let item of _data["RecoverPercentageExceptionListFiles"]) {
          const recoverPercentageExceptionListFiles_ = new File();
          this.RecoverPercentageExceptionListFiles.push(recoverPercentageExceptionListFiles_.init(item));
        }
      }
      if (_data["RejectReasons"] && _data["RejectReasons"].constructor === Array) {
        this.RejectReasons = [];
        for (let item of _data["RejectReasons"]) {
          const rejectReasons_ = new RejectReason();
          this.RejectReasons.push(rejectReasons_.init(item));
        }
      }
      this.ReopenReason = _data["ReopenReason"];
      if (_data["ReturnFiles"] && _data["ReturnFiles"].constructor === Array) {
        this.ReturnFiles = [];
        for (let item of _data["ReturnFiles"]) {
          const returnFiles_ = new File();
          this.ReturnFiles.push(returnFiles_.init(item));
        }
      }
      if (_data["SubmissionErrorFiles"] && _data["SubmissionErrorFiles"].constructor === Array) {
        this.SubmissionErrorFiles = [];
        for (let item of _data["SubmissionErrorFiles"]) {
          const submissionErrorFiles_ = new File();
          this.SubmissionErrorFiles.push(submissionErrorFiles_.init(item));
        }
      }
      if (_data["SubmissionProofs"] && _data["SubmissionProofs"].constructor === Array) {
        this.SubmissionProofs = [];
        for (let item of _data["SubmissionProofs"]) {
          const submissionProofs_ = new SubmissionProof();
          this.SubmissionProofs.push(submissionProofs_.init(item));
        }
      }
      if (_data["TransactionFiles"] && _data["TransactionFiles"].constructor === Array) {
        this.TransactionFiles = [];
        for (let item of _data["TransactionFiles"]) {
          const transactionFiles_ = new File();
          this.TransactionFiles.push(transactionFiles_.init(item));
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["ApprovedBy"] = this.ApprovedBy;
    _data["ClientApprovalDate"] = DateConverter.toUtcDateString(this.ClientApprovalDate);
    if (this.DataVatFiles && this.DataVatFiles.constructor === Array) {
      _data["DataVatFiles"] = [];
      for (let item of this.DataVatFiles) {
        _data["DataVatFiles"].push(item.toJSON());
      }
    }
    if (this.InvalidVatNumbersReportFiles && this.InvalidVatNumbersReportFiles.constructor === Array) {
      _data["InvalidVatNumbersReportFiles"] = [];
      for (let item of this.InvalidVatNumbersReportFiles) {
        _data["InvalidVatNumbersReportFiles"].push(item.toJSON());
      }
    }
    _data["NotToBeSubmittedProof"] = this.NotToBeSubmittedProof ? this.NotToBeSubmittedProof.toJSON() : void 0;
    if (this.OutOfScopeFiles && this.OutOfScopeFiles.constructor === Array) {
      _data["OutOfScopeFiles"] = [];
      for (let item of this.OutOfScopeFiles) {
        _data["OutOfScopeFiles"].push(item.toJSON());
      }
    }
    if (this.RecoverPercentageExceptionListFiles && this.RecoverPercentageExceptionListFiles.constructor === Array) {
      _data["RecoverPercentageExceptionListFiles"] = [];
      for (let item of this.RecoverPercentageExceptionListFiles) {
        _data["RecoverPercentageExceptionListFiles"].push(item.toJSON());
      }
    }
    if (this.RejectReasons && this.RejectReasons.constructor === Array) {
      _data["RejectReasons"] = [];
      for (let item of this.RejectReasons) {
        _data["RejectReasons"].push(item.toJSON());
      }
    }
    _data["ReopenReason"] = this.ReopenReason;
    if (this.ReturnFiles && this.ReturnFiles.constructor === Array) {
      _data["ReturnFiles"] = [];
      for (let item of this.ReturnFiles) {
        _data["ReturnFiles"].push(item.toJSON());
      }
    }
    if (this.SubmissionErrorFiles && this.SubmissionErrorFiles.constructor === Array) {
      _data["SubmissionErrorFiles"] = [];
      for (let item of this.SubmissionErrorFiles) {
        _data["SubmissionErrorFiles"].push(item.toJSON());
      }
    }
    if (this.SubmissionProofs && this.SubmissionProofs.constructor === Array) {
      _data["SubmissionProofs"] = [];
      for (let item of this.SubmissionProofs) {
        _data["SubmissionProofs"].push(item.toJSON());
      }
    }
    if (this.TransactionFiles && this.TransactionFiles.constructor === Array) {
      _data["TransactionFiles"] = [];
      for (let item of this.TransactionFiles) {
        _data["TransactionFiles"].push(item.toJSON());
      }
    }
    return _data;
  }
}
